import { MenuItem, styled } from '@mui/material'

export const ProfileMenuItem = styled(MenuItem)({
  display: 'flex',
  padding: 0,
  color: '#000000',
  '& path': {
    fill: '#999999',
  },
  '&:hover': {
    '&.MuiListItem-button': {
      color: '#141414',
      '& path': {
        fill: '#595959',
      },
    },
  },
})

export const ContractSupportItem = styled(ProfileMenuItem)(({ theme }) => ({
  '& .MuiSvgIcon-root': {
    height: theme.spacing(2.5),
    padding: 0,
    margin: theme.spacing(0.25, 2.5, 0, 0),
    '& path': {
      transform: 'translate(1px, 0px) scale(1.1)',
    },
  },
}))

export const ProfileMenuItemText = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  gap: theme.spacing(1.5),
  alignItems: 'center',
  minHeight: theme.spacing(6),
  color: 'inherit',
  textDecoration: 'none',
  paddingRight: theme.spacing(2),
  paddingLeft: theme.spacing(2),
  width: '100%',
  height: '100%',
  '& svg': {
    width: theme.spacing(2.5),
  },
}))
